const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaGranja: [], listaCliente: [], listaAnimal: [], listaItens: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'VENDA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'VENDA_LISTADO':
            return { ...state, lista: action.payload.data };
		case 'VENDA_ITEM_LISTADO':
			return { ...state, listaItens: action.payload.data };
		case 'VENDA_GRANJA_SELECT_LISTADO':
            return { ...state, listaGranja: action.payload.data };
		case 'VENDA_CLIENTE_SELECT_LISTADO':
            return { ...state, listaCliente: action.payload.data };
		case 'VENDA_ANIMAL_SELECT_LISTADO':
            return { ...state, listaAnimal: action.payload.data };
		default:
            return state;
    }
}
